import React, { useContext } from 'react';
import { useSetRecoilState } from 'recoil';
import { RegularButton as Button } from 'fronton-react';
import { Pencil } from 'assets';
import { RouteContext } from 'entries/common/widgets/context';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { calculationState, useCalculationState } from 'pages/calculation/store/calculation';
import { gaClickOnGoods } from 'ga-events/ga-click-goods';

export const EditParamsButtonComponent: React.FC = () => {
  const { desktop, largeDesktop } = useBreakpoints() ?? {};
  const isLargeScreen = desktop || largeDesktop;
  const setCalculatorState = useSetRecoilState(calculationState);
  const { setContext: setRoute } = useContext(RouteContext);

  const { calculationFormState } = useCalculationState();
  const { addToCartIsSuccessful } = calculationFormState;

  const handleClick = () => {
    gaClickOnGoods({
      title: addToCartIsSuccessful ? 'Добавлено в корзину' : 'Результат по размерам',
      name: 'Изменить параметры',
    });
    setCalculatorState(prevState => ({
      ...prevState,
      count: '',
    }));
    setRoute('dimensions');
  };

  return (
    <Button
      variant={isLargeScreen ? 'secondary' : 'pseudo'}
      size="s"
      label="Изменить параметры"
      type="submit"
      onClick={handleClick}
      {...(!isLargeScreen && { onlyIcon: true })}
      {...(isLargeScreen && { iconLeft: <Pencil /> })}>
      {isLargeScreen ? 'Изменить параметры' : <Pencil />}
    </Button>
  );
};
